const SHOPIFY_DOMAIN_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9-]*\.myshopify\.com$/

/** Validate that the shop parameter is a valid myshopify.com domain */
export function isValidShopDomain(shop: string): boolean {
  return SHOPIFY_DOMAIN_REGEX.test(shop)
}

/** Parses a list of shop domains separated by commas or whitespace, normalized to lowercase. */
export function parseShopDomainList(text: string): { shops: string[]; invalid: string[] } {
  const entries = text.split(/[\s,]+/).map(entry => entry.trim().toLowerCase()).filter(Boolean)
  return {
    shops: [...new Set(entries.filter(isValidShopDomain))],
    invalid: entries.filter(entry => !isValidShopDomain(entry)),
  }
}
